export class ExaView {
    context: any;
    template: any;

    constructor(template, context) {
        this.template = template;
        this.context = context;
    }
}


// WEBPACK FOOTER //
// ./src/app/exa/exa-insert-view/exa-view.ts